export default "__VITE_ASSET__lJ1CT5v9__"